type SuperVoterFeature = {
  title: string
  description: string
}

export const superVoterFeatures: SuperVoterFeature[] = [
  {
    title: "Multi Vote",
    description:
      "Allows you to select one or more NFTs in a wallet and combine their voting power. Multi Vote also includes a max lock on vote for a powerful single transaction.",
  },
  {
    title: "Delegated Vote",
    description:
      "Allows you to delegate an external wallet to vote on your behalf, this enables storing NFTs on a cold wallet (or multisig) and voting with a hot wallet (e.g. while travelling).",
  },
  {
    title: "Multi Max Lock",
    description: "Allows you to select one or more NFTs and max lock them in a single transaction",
  },
  {
    title: "Multi Re-Vote",
    description:
      "Allows you to select one or more NFTs in a wallet and repeat (poke) the previous votes in a single transaction.",
  },
]
